import script from "./ProperMotionPlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ProperMotionPlot.vue?vue&type=script&setup=true&lang=js"

import "./ProperMotionPlot.vue?vue&type=style&index=0&id=3182948d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3182948d"]])

export default __exports__